import { useEffect, useState } from "react";
import { getDireccionesCliente } from "../services/edicionService";

// Direcciones del cliente del pedido, dirección inicial y aviso de coordenadas
// faltantes. "tabla" se recibe porque el original re-evalúa las coordenadas al
// volver de los sub-modales.
export const useDireccionEditar = ({ dataPedido, tabla }) => {
  const [direcciones, setDirecciones] = useState();
  const [direccionSeleccionada, setDireccionSeleccionada] = useState("");
  const [agregarCoordenadas, setAgregarCoordenadas] = useState(false);

  useEffect(() => {
    getDireccionesCliente(dataPedido.id_cliente)
      .then(setDirecciones)
      .catch((error) => {
        // Igual que el original: sin direcciones el autocomplete queda deshabilitado.
        console.error("Error cargando direcciones del cliente:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Dirección inicial: la del pedido.
  useEffect(() => {
    if (dataPedido.id_direccion !== "" && direcciones) {
      const direccionEncontrada = direcciones.find((d) => d.id === dataPedido.id_direccion);
      if (direccionEncontrada) {
        setDireccionSeleccionada(direccionEncontrada);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [direcciones]);

  useEffect(() => {
    if (direccionSeleccionada) {
      setAgregarCoordenadas(
        direccionSeleccionada.latitud === null || direccionSeleccionada.longitud === null,
      );
    }
  }, [direccionSeleccionada, tabla]);

  return { direcciones, direccionSeleccionada, setDireccionSeleccionada, agregarCoordenadas };
};
